import { Trans } from '@lingui/react/macro';

import { cx } from '@/utils/cx';

interface TotalEarnedDisplayProps {
  amountInDollars?: number;
  className?: string;
  isShowCurrency?: boolean;
}

export function TotalEarnedDisplay({
  amountInDollars,
  className,
  isShowCurrency = true,
}: TotalEarnedDisplayProps) {
  return (
    <p className={cx('text-lg text-tertiary lg:text-xl', className)}>
      <Trans>
        🎉
        <span className="text-xl font-semibold text-primary lg:text-2xl">
          {' '}
          ${amountInDollars?.toFixed(2) ?? '0.00'}
        </span>
        {isShowCurrency && <span> USD</span>}
      </Trans>
    </p>
  );
}
